import "./modal.scss";
import m from "mithril"; //import svg from "../svg.js";

export default () => {
    return {
        view: (v) => {
            return m(".prasora-modal-wrapper", {

            }, [
                m(".prasora-modal-div.modal-effect", {
                    class: v.attrs.class,
                    style: `${(v.attrs.height? `height: ${v.attrs.height}vh;`:null)} ${(v.attrs.width? `width: ${v.attrs.width}vw;`:null)}`,
                    onkeydown: e => {
                        // console.log(e);
                    }
                }, [
                    m(".prasora-modal-header", [
                        (v.attrs.title ? m(".prasora-modal-title", v.attrs.title) : null),
                        // v.attrs.allowclose ? m("a.prasora-modal-clear-button", {
                        //     onclick: v.attrs.onclose
                        // }, [
                        //     m(svg, {
                        //         name: "close"
                        //     })
                        // ]) : null
                    ]),
                    m(".prasora-modal-content", [v.children])
                ])
            ]);
        }
    }
}